import { ACTION_WAIT_DEBOUNCE_TIME_MS } from '../../../constants';
import { takeLogout, takeAuth } from '../../auth';
import { safeResolveAsync } from '../../../utils/saga';
import { OK } from 'http-status-codes';
import { debounce, put } from 'redux-saga/effects';
import { getCategoryList } from '../../coupons/api';
import { actions, types } from './duck';

export function* fetchCategoryList({ pageNumber, resolve }) {
  try {
    yield put(actions.getCategoryListRequest());

    const response = yield getCategoryList(pageNumber);
    if (response.status === OK) {
      yield put(actions.getCategoryListSuccess(response.data));
      yield safeResolveAsync(resolve, response.data);
    } else {
      yield put(actions.getCategoryListFailure(response.data.detail));
    }
  } catch (error) {
    yield put(actions.getCategoryListFailure(error.message));
  }
}

export function* initialize() {
  yield put(actions.getCategoryList());
}

export function* clear() {
  yield put(actions.reset());
}

export default function* saga() {
  yield debounce(
    ACTION_WAIT_DEBOUNCE_TIME_MS,
    types.GET_CATEGORY_LIST,
    fetchCategoryList,
  );
  yield takeAuth(initialize);
  yield takeLogout(clear);
}
